export enum DomainEventType {
    JOB_REVIEW_OFFLINE_STORAGE_CHANGE = 'JOB_REVIEW_OFFLINE_STORAGE_CHANGE',
}

export abstract class DomainEvent<P extends object = object> {
    constructor(
        readonly type: DomainEventType,
        readonly payload: P
    ) {}
}
